import script from "./TableArrivedAction.vue?vue&type=script&setup=true&lang=js"
export * from "./TableArrivedAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__